import React, { Component } from 'react';
import moment from 'moment';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { timeDay } from 'd3-time';
import WeeklyChart from './weekly-chart';
import { logEvent } from './amplitude';
import { colors, compilanceStyles } from '../../theme/style';


function TabContainer(props) {
  return (
    <div>
      {props.children}
    </div>
  );
}

// returns all dates that will be represented in the graph
const getDateDomain = (currDate) => {
  const currMonth = currDate.getMonth();
  const currYear = currDate.getFullYear();
  const date = currDate.getDate();
  const currDay = currDate.getDay();

  let firstDay;

  if (currDay === 0) {
    firstDay = new Date(currYear, currMonth, date);
  } else {
    firstDay = new Date(currYear, currMonth, date - currDay);
  }

  const lastDay = new Date(firstDay.getTime() + (7 * 24 * 60 * 60 * 1000));

  // first day included, last day excluded
  return timeDay.range(firstDay, lastDay);
};

class Compliance extends Component {
  state = {
    selectedTab: 'this-week',
    dateDomain: getDateDomain(new Date()),
    today: moment().format('YYYY-MM-DD')
  };
  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value })
  };
  handleSelectTab = (e, selectedTab) => {

    let currDate = new Date();
    if (selectedTab === 'last-week') {
      currDate = new Date(currDate.getTime() - (60 * 60 * 24 * 7 * 1000))
    }

    this.setState({
      dateDomain: getDateDomain(currDate),
      selectedTab,
      data: []
    });

  }
  handleClose = () => {
    this.setState({ open: false });
  };

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleAmplitude = () => {
    return logEvent("Select Last Week");
  }

  render() {

    const { selectedTab } = this.state;
    const { physicalActivity, goal } = this.props;
    return (
      <div style={compilanceStyles.container}>
        <h4 style={{ color: colors.charcoalGrey }}>Compliance Goal: {goal} hours</h4>
        <Tabs value={selectedTab} onChange={this.handleSelectTab} style={{ borderBottom: `1px solid ${colors.slateGrey}`, opacity: 0.7 }}>

          <Tab value="last-week" label="Last Week" onClick={this.handleAmplitude} />
          <Tab value="this-week" label="This Week" />
          <Tab disabled={true} value="custom" label="Custom" />
        </Tabs>
        <div style={compilanceStyles.chartWrapper}>
          {selectedTab === 'last-week' && <WeeklyChart goal={goal} physicalActivity={physicalActivity} min={450} lastWeek={true} />}
          {selectedTab === 'this-week' && <WeeklyChart goal={goal} physicalActivity={physicalActivity} min={450} />}
          {selectedTab === 'custom' && <TabContainer>Custom</TabContainer>}
        </div>
      </div>
    )
  }
}

export default Compliance
